import { render, staticRenderFns } from "./FormPost.vue?vue&type=template&id=919b523c&scoped=true"
import script from "./FormPost.vue?vue&type=script&lang=js"
export * from "./FormPost.vue?vue&type=script&lang=js"
import style0 from "./FormPost.vue?vue&type=style&index=0&id=919b523c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919b523c",
  null
  
)

export default component.exports